<template>
    <v-card component="ShortlistCharacter">
        <shortlist-header :project="getProject" />

        <v-card-text class="shortlist">
            <v-card
                v-for="(character, index) in getProject.characters"
                :key="`shortlist-${index}`"
                class="character"
                :style="{ background: `${getColorById(character.farba)}!important` }"
                :class="{ selected: isCharacterSelected(character) }"
            >
                <shortlist-character-header :character="character" />
                <shortlist-character-list :characterIn="character" />
            </v-card>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import ShortlistCharacterList from '@/components/Project/Shortlist/ShortlistCharacterList.vue';
import ShortlistHeader from '@/components/Project/Shortlist/ShortlistHeader';
import ShortlistCharacterHeader from '@/components/Project/Shortlist/ShortlistCharacterHeader.vue';

export default {
    name: 'ShortlistCharacter',

    data() {
        return {
            projectVideoDialogCharacter: null,
        };
    },

    async mounted() {},

    computed: {
        ...mapGetters(['getProject', 'getColorById', 'getSelectedCharacter']),
    },

    methods: {
        ...mapActions([]),
        ...mapMutations([]),

        isCharacterSelected(character) {
            return this.getSelectedCharacter.id === character.id;
        },
    },

    components: {
        ShortlistCharacterHeader,
        ShortlistHeader,
        ShortlistCharacterList,
    },
};
</script>

<style lang="less">
@import '~@variables';

.flip-list-move {
    transition: transform 0.5s;
}

.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}

[component='ShortlistCharacter'] {
    /// len kvoli dragu
    .candidate-actions {
        .col {
            display: flex;
        }
    }

    .shortlist {
        overflow: auto;
        height: 0;
        flex-grow: 1;
    }

    .character {
        margin-bottom: 10px;
        display: flex;
        flex-direction: column;

        &.rounded {
            border-radius: 23px !important;
        }

        &.selected {
            .title .name {
                background-color: rgba(255, 255, 255, 0.3);
            }
        }

        .title {
            .font;
            justify-content: space-between;
            flex-wrap: nowrap;
            font-size: 15px !important;
            padding: 6px 6px 6px 8px !important;
            font-weight: 700;
            color: black;
            //background: rgba(255, 255, 255, 0.3);
            border-radius: 0;
            cursor: pointer;

            .name {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                background: rgba(255, 255, 255, 0);
                padding: 0 7px;
                border-radius: 10px;
            }
        }
    }
}
</style>
